import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "../../../utils/cn";
const Mark = ({ percentage, children, isActive, }) => {
    if (percentage === 100)
        percentage = 99.3;
    return (_jsxs("div", { style: { left: `${percentage}%` }, className: "absolute z-10", children: [_jsx("div", { className: cn("absolute left-0 h-1 w-0.5 bg-opacity-50", isActive ? "bg-primary-10" : "bg-gray-8", percentage === 0 && "rounded-l", percentage === 99.3 && "rounded-r") }), children] }));
};
export default Mark;
